import React from "react";
import { Box } from "@mui/material";
import Footer from "../../Components/Common/Footer";
import Layout from "../../layouts/Layout";
import Guidelines from "../../Components/CommunityGuidelines/Guidelines";

const CommunityGuidelines = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: "#FC0108",
          color: "white",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <Box maxWidth="md" sx={{ margin: "0 auto", padding: 2 }}>
          <h1 style={{ fontWeight: "bold", marginBottom: "16px" }}>
            Community Guidelines
          </h1>
          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              marginBottom: "24px",
            }}
          >
            Our community guidelines are designed to ensure a safe, respectful,
            and high-quality environment for all OnlyHands users. Please read
            and adhere to these guidelines to maintain a positive experience for
            everyone.
          </p>
        </Box>
      </Box>
      {/* Guidelines Content */}
      <Guidelines />
      {/* <Footer /> */}
    </Layout>
  );
};

export default CommunityGuidelines;
